import React from 'react';
import clsx from 'clsx';
import NoRows from '@/components/table/NoRows';
import FormLinkListItems from './FormLinkListItems';

const FormLinksList = ({
  addItem,
  canEdit,
  className,
  code,
  entity,
  field,
  showItem,
  text = [],
}) => (
  <div className={clsx('aridhia-form-links-list', field.code, className)}>
    <FormLinkListItems
      canEdit={canEdit}
      code={code}
      field={field}
      items={text}
      showItem={showItem}
    />
    {text.length === 0 && (
    <NoRows
      buttonText={field.placeholder}
      className="min-h-35"
      entity={entity}
      onClick={canEdit ? () => addItem() : undefined}
    />
    )}
  </div>
);

export default FormLinksList;
